import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogReplyAvatarsListItem from './VeltCommentDialogReplyAvatarsListItem/VeltCommentDialogReplyAvatarsListItem';
var VeltCommentDialogReplyAvatarsList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-reply-avatars-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogReplyAvatarsList.Item = VeltCommentDialogReplyAvatarsListItem;
export default VeltCommentDialogReplyAvatarsList;
